/**
 * Opening Hours Sticker Customizer JS
 * Version: 4.0 (Unified Smart Textbox)
 */
(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {
        const root = document.querySelector('[data-ohs-root]');
        if (!root) return;

        // --- DOM Elements ---
        const form = root.querySelector('form[data-type="add-to-cart-form"]');
        const variantInput = form.querySelector('input[name="id"]');
        const textInput = root.querySelector('#OpeningHours');
        const stickerFont = root.querySelector('#StickerFont');
        const slider = root.querySelector('#SizeSlider');
        const sizeDisplay = root.querySelector('#SizeValueDisplay');
        const lineSpacingInput = root.querySelector('#LineSpacing');
        const lineSpacingVal = root.querySelector('#LineSpacingVal');
        const mirrorCheckbox = root.querySelector('#MirrorEffect');
        const ohsConfigInput = root.querySelector('#OhsConfig');
        const ohsSvgInput = root.querySelector('#OhsSvg');

        // Nav
        const nextBtn = root.querySelector('#NextStep');
        const prevBtn = root.querySelector('#PrevStep');
        const stepTitle = root.querySelector('#StepTitle');
        const summaryBox = root.querySelector('#OhsSummary');
        const charCountDisplay = root.querySelector('#CharCount');

        // SVG
        const stickerSvg = root.querySelector('#StickerSvg');
        const stickerRect = root.querySelector('#StickerRect');
        const safeRect = root.querySelector('#SafeRect');
        const clipRect = root.querySelector('#ClipRect');
        const svgText = root.querySelector('#SvgText');
        const stickerGroup = root.querySelector('#StickerGroup');
        const qualityFill = root.querySelector('#QualityFill');
        const qualityStatus = root.querySelector('#QualityStatus');

        // State
        const state = {
            currentStep: 1,
            totalSteps: 5,
            preset: 'classic',
            align: 'middle',
            lineSpacing: 1.2,
            width: 30,
            height: 20,
            scene: 'neutral'
        };

        const sceneMetadata = {
            neutral: { w: 50, h: 50 },
            window: { w: 100, h: 80 },
            door: { w: 80, h: 120 },
            wall: { w: 100, h: 80 }
        };

        // The font list lives in snippets/ibl-font-select.liquid. Read the
        // stack off the selected <option> so there is only one place to edit.
        const selectedFont = () => stickerFont.options[stickerFont.selectedIndex];

        const SVG_SIZE = 500;

        // --- CORE LOGIC ---

        function updatePreview() {
            // 1. Geometry
            const idx = slider.value;
            state.width = parseFloat(slider.getAttribute(`data-v-w-${idx}`));
            state.height = parseFloat(slider.getAttribute(`data-v-h-${idx}`));
            const scene = sceneMetadata[state.scene];
            const scale = SVG_SIZE / scene.w;

            const svgW = state.width * scale;
            const svgH = state.height * scale;
            const rectX = (SVG_SIZE - svgW) / 2;
            const rectY = (SVG_SIZE - svgH) / 2;

            [stickerRect, clipRect].forEach(el => {
                el.setAttribute('width', svgW);
                el.setAttribute('height', svgH);
                el.setAttribute('x', rectX);
                el.setAttribute('y', rectY);
            });

            const safePadding = svgW * 0.05;
            const totalSafeW = svgW - safePadding * 2;
            const totalSafeH = svgH - safePadding * 2;

            safeRect.setAttribute('width', totalSafeW);
            safeRect.setAttribute('height', totalSafeH);
            safeRect.setAttribute('x', rectX + safePadding);
            safeRect.setAttribute('y', rectY + safePadding);

            // 2. Style
            const colorInput = root.querySelector('input[name="properties[Farbe]"]:checked');
            if (!colorInput) return;
            const colorHex = colorInput.getAttribute('data-hex');
            const colorVal = colorInput.value;

            let fill = colorHex;
            if (colorVal.includes("Gold")) fill = "url(#GoldGradient)";
            if (colorVal.includes("Rainbow")) fill = "url(#HoloGradient)";

            svgText.setAttribute('fill', fill);
            const chosenFont = selectedFont();
            svgText.style.fontFamily = chosenFont.dataset.stack;
            // Use the weight that was actually loaded — a synthesised bold cannot be printed.
            svgText.style.fontWeight = chosenFont.dataset.weight;
            svgText.setAttribute('text-anchor', state.align);
            svgText.style.filter = 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))';

            // 3. Render and Scale
            const renderText = (fSize) => {
                while (svgText.firstChild) svgText.removeChild(svgText.firstChild);
                const lines = textInput.value.split('\n');
                const fScale = fSize / 100; // Reference scale
                const lH = fSize * state.lineSpacing;

                let anchorX = 250;
                if (state.align === 'start') anchorX = rectX + safePadding + 5;
                if (state.align === 'end') anchorX = rectX + svgW - safePadding - 5;

                svgText.style.fontSize = `${fSize}px`;
                svgText.setAttribute('y', rectY); // Base position before adjustment

                lines.forEach((line, i) => {
                    const tspan = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
                    tspan.setAttribute('x', anchorX);
                    tspan.setAttribute('dy', i === 0 ? "0.8em" : lH); // Multi-line start offset
                    tspan.textContent = line || ' '; // Handle empty lines
                    svgText.appendChild(tspan);
                });

                // Vertical Centering (One-time adjustment at the end of renderText)
                const bbox = svgText.getBBox();
                const centerY = rectY + (svgH / 2);
                const textCenter = bbox.y + (bbox.height / 2);
                const currentY = parseFloat(svgText.getAttribute('y') || rectY);
                svgText.setAttribute('y', currentY + (centerY - textCenter));
            };

            let fontSize = 150; // High starting point for scaling
            renderText(fontSize);

            let its = 0;
            const maxIts = 50;
            while (its < maxIts) {
                const b = svgText.getBBox();
                // Check if it fits in safe area
                if (b.width > totalSafeW - 4 || b.height > totalSafeH - 4) {
                    fontSize *= 0.92;
                    renderText(fontSize);
                    its++;
                } else {
                    break;
                }
            }

            // 4. Effects
            stickerGroup.setAttribute('transform', mirrorCheckbox.checked ? `scale(-1, 1) translate(-500, 0)` : '');

            // 5. Save
            charCountDisplay.textContent = `${textInput.value.length} Zeichen`;
            ohsConfigInput.value = JSON.stringify({ preset: state.preset, align: state.align, spacing: state.lineSpacing, font: stickerFont.value });
            if (ohsSvgInput) ohsSvgInput.value = stickerSvg.outerHTML;

            updateQuality(textInput.value.length / (state.width * state.height));
        }

        function updateQuality(density) {
            let score = 100;
            if (density > 2.5) score = 70;
            if (density > 4.5) score = 30;
            qualityFill.style.width = `${score}%`;
            qualityFill.style.backgroundColor = score > 60 ? '#16a34a' : (score > 30 ? '#eab308' : '#ef4444');
            qualityStatus.textContent = score > 60 ? 'Exzellent' : (score > 30 ? 'Viel Text' : 'Nicht lesbar');
        }

        const stepSubtitle = root.querySelector('#StepSubtitle');

        function updateStepper() {
            // Updated Stepper Logic (Dots & Lines)
            const dots = root.querySelectorAll('.ohs__dot');
            const lines = root.querySelectorAll('.ohs__step-line');
            const panels = root.querySelectorAll('.ohs__step-panel');

            panels.forEach(p => p.classList.toggle('active', p.dataset.step == state.currentStep));

            dots.forEach((dot, i) => {
                const n = i + 1;
                dot.classList.toggle('active', n == state.currentStep);
                dot.classList.toggle('completed', n < state.currentStep);
            });

            lines.forEach((line, i) => {
                line.classList.toggle('completed', i + 1 < state.currentStep);
            });

            const titles = ["Text", "Größe", "Farbe", "Optionen", "Bestätigung"];
            const subtitles = [
                "Geben Sie den gewünschten Text und die Schriftart ein.",
                "Wählen Sie das optimale Format für Ihren Aufkleber.",
                "Wählen Sie die passende Farbe aus unserer Oracal-Palette.",
                "Passen Sie Ausrichtung und Zeilenabstand individuell an.",
                "Überprüfen Sie Ihre Konfiguration vor der Bestellung."
            ];

            stepTitle.textContent = `Schritt ${state.currentStep} – ${titles[state.currentStep - 1]}`;
            if (stepSubtitle) stepSubtitle.textContent = subtitles[state.currentStep - 1];

            prevBtn.classList.toggle('hidden', state.currentStep == 1);
            nextBtn.classList.toggle('hidden', state.currentStep == 5);
            if (state.currentStep == 5) renderSummary();
        }

        function renderSummary() {
            const color = root.querySelector('input[name="properties[Farbe]"]:checked').value;
            summaryBox.innerHTML = `
                <div class="ohs__summary-row"><span>Text:</span><strong>${textInput.value.substring(0, 20)}...</strong></div>
                <div class="ohs__summary-row"><span>Größe:</span><strong>${state.width}x${state.height}cm</strong></div>
                <div class="ohs__summary-row"><span>Farbe:</span><strong>${color}</strong></div>
            `;
            root.querySelector('#SummaryPrice').textContent = slider.getAttribute(`data-v-price-${slider.value}`);
        }

        // --- LISTENERS ---
        textInput.addEventListener('input', updatePreview);
        stickerFont.addEventListener('change', updatePreview);

        // The preview scales the text to fit its box, so it must be laid out with the
        // real face. Re-render once the webfonts have loaded.
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(updatePreview);
        }
        slider.addEventListener('input', (e) => {
            sizeDisplay.textContent = e.target.getAttribute(`data-v-title-${e.target.value}`);
            variantInput.value = e.target.getAttribute(`data-v-id-${e.target.value}`);
            updatePreview();
        });
        nextBtn.addEventListener('click', () => { if (state.currentStep < 5) { state.currentStep++; updateStepper(); } });
        prevBtn.addEventListener('click', () => { if (state.currentStep > 1) { state.currentStep--; updateStepper(); } });

        root.querySelectorAll('.ohs__preset-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                root.querySelectorAll('.ohs__preset-btn').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                state.preset = btn.dataset.preset;
                state.lineSpacing = state.preset === 'compact' ? 1.05 : (state.preset === 'wide' ? 1.6 : 1.25);
                lineSpacingInput.value = state.lineSpacing;
                lineSpacingVal.textContent = state.lineSpacing;
                updatePreview();
            });
        });

        root.querySelectorAll('.ohs__align-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                root.querySelectorAll('.ohs__align-btn').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                state.align = btn.dataset.align;
                updatePreview();
            });
        });

        lineSpacingInput.addEventListener('input', (e) => {
            state.lineSpacing = e.target.value;
            lineSpacingVal.textContent = e.target.value;
            updatePreview();
        });

        mirrorCheckbox.addEventListener('change', updatePreview);
        root.querySelectorAll('.ohs__mockup-tab').forEach(tab => {
            tab.addEventListener('click', () => {
                root.querySelectorAll('.ohs__mockup-tab').forEach(t => t.classList.remove('active'));
                tab.classList.add('active');
                state.scene = tab.dataset.scene;
                root.querySelector('#PreviewFrame').className = `ohs__preview-container scene--${state.scene}`;
                updatePreview();
            });
        });

        root.querySelector('#ToggleMoreColors').addEventListener('click', () => {
            root.querySelector('#ColorAccordion').classList.toggle('active');
        });

        root.addEventListener('change', (e) => { if (e.target.name === 'properties[Farbe]') updatePreview(); });

        updateStepper();
        updatePreview();
    });
})();
